import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LANDING_LINKS } from '@/config/landing-links';

import footerStyles from '../../LandingFooter.module.sass';
import styles from './FooterCompany.module.sass';

export const FooterCompany = () => {
  const { t } = useTranslation();

  return (
    <nav className={styles.company}>
      <div className={footerStyles.title}>
        {t('translation.landingFooter.company')}
      </div>
      <ul className={footerStyles.list}>
        <li>
          <Link
            to={LANDING_LINKS.ABOUTUS_PAGE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={footerStyles.link}
          >
            {t('translation.landingFooter.aboutUs')}
          </Link>
        </li>
        <li>
          <Link
            to={LANDING_LINKS.ANALYZE_PAGE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={footerStyles.link}
          >
            {t('translation.landingFooter.analysis')}
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.CERTIFICATIONS_PAGE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={footerStyles.link}
          >
            {t('translation.landingFooter.certifications')}
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.BLOG_PAGE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={footerStyles.link}
          >
            {t('translation.landingFooter.blog')}
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.PRESSKIT_PAGE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={footerStyles.link}
          >
            {t('translation.landingFooter.pressKit')}
          </Link>
        </li>

        <li>
          <Link
            to={LANDING_LINKS.CAREERS_PAGE_URL}
            rel="noreferrer nofollow"
            target="_blank"
            className={footerStyles.link}
          >
            {t('translation.landingFooter.careers')}
          </Link>
        </li>
      </ul>
    </nav>
  );
};
